import localForage from "localforage";

localForage.config({
    name        : 'CAMP_APP',
    version     : 1.0,
    storeName   : 'CAMP_APP'
});

export const storage:LocalForage = localForage;